import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminLogin from "../component/auth/AdminLogin";
import Login from "../component/auth/Login";
import Dashboard from "../component/Dashboard";

import CompletedJobs from "../component/CompletedJobs";
import PrivateRoute from "./privateRoute";
import UserManagementRoutes from "./userManagementRoute";
import ForgotPassword from "../component/ForgotPassword";
import MyProfile from "../component/MyProfile";
import ResetPassword from "../component/ResetPassword";
import Job from "../component/Job";

const AppRoute = () => {
  return (
    <Router>
      <Routes>
        <Route path="/admin">
          <Route index element={<AdminLogin />} />

          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route
            path="dashboard"
            exact
            element={
              <PrivateRoute moduleName="OPEN" allowedRoles={[1, 2]}>
                <Dashboard isSupplierDashboard={0} />
              </PrivateRoute>
            }
          />

          <Route
            path="supplier-dashboard"
            exact
            element={
              <PrivateRoute moduleName="OPEN" allowedRoles={[1, 2, 4]}>
                <Dashboard isSupplierDashboard={1} />
              </PrivateRoute>
            }
          />

          <Route
            path="completed-jobs"
            exact
            element={
              <PrivateRoute moduleName="OPEN">
                <CompletedJobs isSupplierDashboard={0} />
              </PrivateRoute>
            }
          />

          <Route
            path="supplier-completed-jobs"
            exact
            element={
              <PrivateRoute moduleName="OPEN">
                <CompletedJobs isSupplierDashboard={1} />
              </PrivateRoute>
            }
          />

          <Route
            path="jobs/add"
            moduleName="JOBS"
            element={
              <PrivateRoute moduleName="JOBS">
                <Job />
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="jobs/:job_id"
            moduleName="JOBS"
            element={
              <PrivateRoute moduleName="JOBS">
                <Job />
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="my-profile"
            element={
              <PrivateRoute moduleName="OPEN">
                <MyProfile />
              </PrivateRoute>
            }
          />

          <Route
            path="user-management/*"
            element={
              <PrivateRoute moduleName="USER_MANAGEMENT">
                <UserManagementRoutes />
              </PrivateRoute>
            }
          ></Route>
        </Route>

        <Route path="/">
          <Route index element={<Login />} />

          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route path="reset-password/:token" element={<ResetPassword />} />

          <Route
            path="dashboard"
            exact
            element={
              <PrivateRoute moduleName="OPEN" allowedRoles={[3]}>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="jobs/add"
            moduleName="JOBS"
            element={
              <PrivateRoute moduleName="JOBS">
                <Job />
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="jobs/:job_id"
            moduleName="JOBS"
            element={
              <PrivateRoute moduleName="JOBS">
                <Job />
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="my-profile"
            element={
              <PrivateRoute moduleName="OPEN">
                <MyProfile />
              </PrivateRoute>
            }
          />

          <Route
            path="completed-jobs"
            exact
            element={
              <PrivateRoute moduleName="OPEN">
                <CompletedJobs />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default React.memo(AppRoute);
